/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSocialSettingRequest } from '../models/CreateSocialSettingRequest';
import type { SocialSettingDto } from '../models/SocialSettingDto';
import type { UpdateSocialSettingRequest } from '../models/UpdateSocialSettingRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SocialSettingControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SocialSettingDto OK
     * @throws ApiError
     */
    public getByShopId({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<SocialSettingDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/social-settings/shop/{shopId}',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SocialSettingDto OK
     * @throws ApiError
     */
    public updateByShopId({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: UpdateSocialSettingRequest,
    }): CancelablePromise<SocialSettingDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/social-settings/shop/{shopId}',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public deleteByShopId({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/social-settings/shop/{shopId}',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SocialSettingDto OK
     * @throws ApiError
     */
    public create({
        requestBody,
    }: {
        requestBody: CreateSocialSettingRequest,
    }): CancelablePromise<SocialSettingDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/social-settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SocialSettingDto OK
     * @throws ApiError
     */
    public getAll(): CancelablePromise<Array<SocialSettingDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/social-settings/all',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
